import React, { useState } from 'react';
import { View, Text, TextInput, Pressable, StyleSheet } from 'react-native';
import { textStyle } from '../styles';
import authService from '../services/authService';

interface Props {
  onSubmit: () => void;
}

export default function TokenPrompt({ onSubmit }: Props) {
  const [token, setToken] = useState('');
  const [name, setName] = useState('Test User');

  const handleSubmit = () => {
    if (!token.trim() || !name.trim()) return;
    authService.setManualCredentials(token.trim(), name.trim());
    onSubmit();
  };

  return (
    <View style={styles.root}>
      <Text style={styles.heading}>Enter Credentials</Text>
      <Text style={styles.label}>Auth Token</Text>
      <TextInput
        style={styles.input}
        value={token}
        onChangeText={setToken}
        placeholder="Paste MAP bearer token"
        placeholderTextColor="#94A3B8"
        autoCapitalize="none"
        autoCorrect={false}
      />
      <Text style={styles.label}>Name</Text>
      <TextInput
        style={styles.input}
        value={name}
        onChangeText={setName}
        placeholder="Your display name"
        placeholderTextColor="#94A3B8"
      />
      <Pressable
        style={[styles.button, (!token.trim() || !name.trim()) && styles.buttonDisabled]}
        onPress={handleSubmit}
        disabled={!token.trim() || !name.trim()}
      >
        <Text style={styles.buttonText}>Continue</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#FFF8F0',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
  },
  heading: {
    fontSize: 20,
    ...textStyle.heading,
    color: '#1E293B',
    marginBottom: 24,
  },
  label: {
    fontSize: 14,
    ...textStyle.heading,
    color: '#475569',
    alignSelf: 'stretch',
    maxWidth: 400,
    marginBottom: 4,
  },
  input: {
    width: '100%',
    maxWidth: 400,
    borderWidth: 1,
    borderColor: '#CBD5E1',
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: '#1E293B',
    ...textStyle.body,
    backgroundColor: '#FFFFFF',
    marginBottom: 16,
  },
  button: {
    backgroundColor: '#6366F1',
    paddingVertical: 12,
    paddingHorizontal: 32,
    borderRadius: 8,
    marginTop: 8,
  },
  buttonDisabled: {
    opacity: 0.5,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 16,
    ...textStyle.heading,
  },
});
